module.exports = __webpack_public_path__ + "img/pic_19.93e918ae.jpg";